import { cn } from '@Utils/cn';
import type { GuestSpendSummary } from '../types';

export interface GuestSpendStatsProps {
  spendSummary: GuestSpendSummary;
  className?: string;
}

const STATS: { key: keyof GuestSpendSummary; label: string }[] = [
  { key: 'mtdSpend', label: 'MTD Spend' },
  { key: 'ytdSpend', label: 'YTD Spend' },
  { key: 'allTimeSpend', label: 'All Time Spend' },
];

/** Month-to-date, year-to-date and lifetime spend; dark under a `.dark` ancestor. */
export function GuestSpendStats({
  spendSummary,
  className,
}: GuestSpendStatsProps) {
  return (
    <div className={cn('flex items-center gap-8 py-2', className)}>
      {STATS.map((stat) => (
        <div key={stat.key} className="flex flex-col items-center">
          <span className="text-xs font-bold tracking-wide text-aoh-muted uppercase dark:text-sm dark:font-normal dark:tracking-normal dark:text-[#c6a868] dark:normal-case">
            {stat.label}
          </span>
          <span className="text-xl font-extrabold text-aoh-ink dark:font-bold dark:text-white">
            {spendSummary[stat.key]}
          </span>
        </div>
      ))}
    </div>
  );
}
